let region_routes = [
  {
    path: '/',
    component: () => import('Modules/Dashboard/resources/layout/DashboardLayout.vue'),
    children: [
      { path: 'countries', name: 'countries.list', component: () => import('./pages/Country/Index.vue') },
      { path: 'countries/create', name: 'countries.create', component: () => import('./pages/Country/Create.vue') },
      { path: 'countries/:id/edit', name: 'countries.edit', component: () => import('./pages/Country/Edit.vue') }
    ]
  }
];

export default region_routes;
